import { tryInitScholarshipApplyPageScript } from "@/pages/scholarships/Apply";

/**
 * Returns whether the current page URL is the specified page
 * @param pagePath The page path. Format: "/some/page".
 * @returns True if the current page URL is the specified page
 */
export function isOnThisPage(pagePath: string): boolean
{
    return window.location.pathname === pagePath;
}

/**
 * Runs a page's custom TypeScript, if this page has any
 */
export function tryInitPageScript()
{
    window.addEventListener("load", event =>
    {
        tryInitScholarshipApplyPageScript();
    })
}
